import { render, staticRenderFns } from "./connection-details.vue?vue&type=template&id=b6655bae&scoped=true&"
import script from "./connection-details.vue?vue&type=script&lang=ts&"
export * from "./connection-details.vue?vue&type=script&lang=ts&"
import style0 from "./connection-details.vue?vue&type=style&index=0&id=b6655bae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6655bae",
  null
  
)

export default component.exports